import type { Connection } from "@/lib/types";

export function findOwnedConnection(
  value: unknown,
  id: string,
): Connection | undefined {
  if (!value || typeof value !== "object") return;
  if (Array.isArray(value)) {
    for (const item of value) {
      const found = findOwnedConnection(item, id);
      if (found) return found;
    }
    return;
  }
  const record = value as Record<string, unknown>;
  if (Array.isArray(record.connections)) {
    const found = (record.connections as Connection[]).find(
      (connection) => connection.id === id,
    );
    if (found) return found;
  }
  for (const [key, child] of Object.entries(record)) {
    if (key === "connections" || key === "contact") continue;
    if (Array.isArray(child) || key === "data") {
      const found = findOwnedConnection(child, id);
      if (found) return found;
    }
  }
}

export function findOwnedConnections(value: unknown): Connection[] {
  const found = new Map<string, Connection>();
  const visit = (child: unknown): void => {
    if (!child || typeof child !== "object") return;
    if (Array.isArray(child)) {
      child.forEach(visit);
      return;
    }
    const record = child as Record<string, unknown>;
    if (Array.isArray(record.connections))
      for (const connection of record.connections as Connection[])
        found.set(connection.id, connection);
    for (const [key, nested] of Object.entries(record))
      if (key !== "connections" && (Array.isArray(nested) || key === "data"))
        visit(nested);
  };
  visit(value);
  return [...found.values()];
}
